/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type McpNetworkTrafficPoint = {
  /**
   * Start of the UTC hour
   */
  bucketStart: Date;
  /**
   * Observed private requests
   */
  privateRequests: number;
  /**
   * Observed public requests
   */
  publicRequests: number;
};

/** @internal */
export const McpNetworkTrafficPoint$inboundSchema: z.ZodMiniType<
  McpNetworkTrafficPoint,
  unknown
> = z.pipe(
  z.object({
    bucket_start: z.pipe(
      z.iso.datetime({ offset: true }),
      z.transform(v => new Date(v)),
    ),
    private_requests: z.int(),
    public_requests: z.int(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "bucket_start": "bucketStart",
      "private_requests": "privateRequests",
      "public_requests": "publicRequests",
    });
  }),
);

export function mcpNetworkTrafficPointFromJSON(
  jsonString: string,
): SafeParseResult<McpNetworkTrafficPoint, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => McpNetworkTrafficPoint$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'McpNetworkTrafficPoint' from JSON`,
  );
}
